import { DateTime } from "luxon";

// Vietnamese Luxon outputs "thg 1" / "tháng 1" for MMM/MMMM, which reads awkwardly
// in compact UI (chart axes, picker grids, period labels). Compress to "T1".
export function formatLocalizedDate(dt: DateTime, format: string, locale: string): string {
  const result = dt.setLocale(locale).toFormat(format);
  if (locale.startsWith("vi")) {
    return result.replace(/\b[Tt]hg\s+(\d+)/g, "T$1").replace(/\b[Tt]háng\s+(\d+)/g, "T$1");
  }
  return result;
}
